import React, { useState, useRef } from 'react';
import ReactDOM from 'react-dom';
import { IconHelp, IconX } from "@tabler/icons-react";
import { notifications } from '@mantine/notifications';
import { modals } from '@mantine/modals';
import { Text, Button } from '@mantine/core';
import TestsApi from "../../api/TestsApi";
import { SelectTooltip } from "../../components/GeneralComponent/GeneralComponent";

export function UnsetWinner({
    SelectedThumbnail,
    SystemUsageLoader,
    SelectedMemberWebsite,
    MarkSalesTime,
  }:any) {

  const unsetWinnerRef = useRef(null);
  const [showHelpModal, setShowHelpModal] = useState(false);
  const [helpTargetId, setHelpTargetId] = useState(0);
  const [tooltipPosition, setTooltipPosition] = useState({ top: 0, left: 0 });

  const handleRemoveSetWinner = async (SelectedThumbnail) => {
    modals.openConfirmModal({
      trapFocus: false,
      title: 'Unset Winner',
      children: (
        <Text size="sm">
         Are you sure you want to remove "Set winner"?<br/>
         If you do this winner variation will stop being served to visitors, instead they will start seeing the control variation of the page again.
        </Text>
      ),
      labels: { confirm: 'Unset Winner', cancel: 'Cancel' },
      confirmProps: { color: 'red' },
      onCancel: () => console.log('Cancel'),
      onConfirm: () => {
        handleUnsetwinner(SelectedThumbnail);
      },
    });
  }

  const handleUnsetwinner = async (SelectedThumbnail) =>{
    try {
      SystemUsageLoader(true);
      const APIResponse = await TestsApi.unsetwinner({
        page_id: SelectedThumbnail,
        system_website_id : SelectedMemberWebsite,
      });
      const APIResultJSON = await APIResponse.json();
      MarkSalesTime(APIResultJSON.data.updatedtime);
      if (APIResultJSON.status === 1) {
        SystemUsageLoader(false);
      }else{
        notifications.show({
          color: 'red',
          icon: <IconX size="1.1rem" />,
          title: 'Error',
          message: APIResultJSON.message,
        });
        SystemUsageLoader(false);
      }
    } catch (error) {
      SystemUsageLoader(false);
      console.error("API Error:", error);
    }
  };

  const handleHelpClick = (id:any) => {
    setShowHelpModal(true);
    setHelpTargetId(id);
    if (unsetWinnerRef.current) {
      const { top, left, width } = unsetWinnerRef.current.getBoundingClientRect();
      const scrollOffset = window.scrollY;
      setTooltipPosition({
        top: top + scrollOffset - 300,
        left: left + width - 420, 
      });
    }
  };

  return (
    <>
      {showHelpModal &&
      ReactDOM.createPortal(
        <div style={{ zIndex: 9999 }}>
          <SelectTooltip
            isVisible={showHelpModal}
            setIsVisible={setShowHelpModal}
            id={helpTargetId}
            tooltipPosition={tooltipPosition}
          />
        </div>,
        document.body
      )}
      <Text weight={500}>
        <IconHelp ref={unsetWinnerRef} size="1.1rem" color="red" style={{marginTop: 11, marginLeft: 10, cursor: 'pointer'}} onClick={() => handleHelpClick(306)}/>
      </Text>
      <Button color="red" type="button" style={{ marginLeft: 7 }} onClick={() => handleRemoveSetWinner(SelectedThumbnail)}>
        Remove "Set Winner"
      </Button>
    </>
  );
}